import React from 'react';
import './Privacy&policies.css';

const PrivacyPolicies = () => {
	return (
		<main className="privacy-page">
			<section className="privacy-header">
				<div className="container">
					<h1>Privacy Policy</h1>
					<p>How West Drayton Body Works Ltd protects and uses your information</p>
				</div>
			</section>

			<div className="container p-40">
				<section className="privacy-content">
					<div className="privacy-section">
						<h2>1. Our Commitment to Your Privacy</h2>
						<p>
							West Drayton Body Works Ltd respects your privacy and is committed to protecting
							your personal information. We do not misuse, sell, rent, or share customer
							information for unrelated marketing purposes.
						</p>
						<p>
							This policy explains what information we collect, why we need it, how we protect it,
							and the rights you have over your information.
						</p>
					</div>

					<div className="privacy-section">
						<h2>2. Information We Collect</h2>
						<p>Depending on how you contact us, we may collect:</p>
						<ul>
							<li>Your name and contact details, including email address and telephone number</li>
							<li>Vehicle details, including registration number, make, model, and year</li>
							<li>Details about your repair enquiry, quotation, order, or service request</li>
							<li>Delivery and billing information when you purchase a product</li>
							<li>Messages, photographs, and other information you choose to send to us</li>
						</ul>
					</div>

					<div className="privacy-section">
						<h2>3. How We Use Your Information</h2>
						<p>We use your information only when it is necessary to:</p>
						<ul>
							<li>Respond to enquiries and provide quotes</li>
							<li>Arrange and carry out vehicle repair or parts-related services</li>
							<li>Process orders, payments, returns, refunds, and deliveries</li>
							<li>Contact you about your request, appointment, order, or warranty</li>
							<li>Keep appropriate business, accounting, and legal records</li>
							<li>Improve our services and protect our website and customers from fraud</li>
						</ul>
						<p>We will not use your information for a different purpose without explaining why and, where required, obtaining your consent.</p>
					</div>

					<div className="privacy-section">
						<h2>4. When We Share Information</h2>
						<p>
							We do not sell customer information. We share the minimum information necessary
							only with trusted service providers when required to provide a service, such as
							payment providers, delivery companies, insurers, professional advisers, or our
							website and email service providers.
						</p>
						<p>
							These providers may use information only to perform the service we have requested.
							We may also disclose information where required by law or to protect our legal
							rights, customers, staff, or property.
						</p>
					</div>

					<div className="privacy-section">
						<h2>5. Keeping Your Information Secure</h2>
						<p>
							We take reasonable technical and organisational measures to protect personal
							information from unauthorised access, loss, misuse, alteration, or disclosure.
							Access is limited to people who need the information for legitimate business
							purposes.
						</p>
						<p>
							However, no internet transmission or electronic storage system can be guaranteed to
							be completely secure. Please contact us promptly if you believe your information has
							been used incorrectly.
						</p>
					</div>

					<div className="privacy-section">
						<h2>6. How Long We Keep Information</h2>
						<p>
							We keep information only for as long as reasonably necessary for the purpose it was
							collected, including to provide services, manage warranties, meet accounting and
							legal requirements, and resolve disputes. When information is no longer needed, we
							securely delete it or anonymise it where appropriate.
						</p>
					</div>

					<div className="privacy-section">
						<h2>7. Cookies and Website Use</h2>
						<p>
							Our website may use essential technologies needed for basic operation and security.
							We do not use customer information from this website to create intrusive profiles or
							sell targeted advertising data. Your browser may also provide controls for managing
							cookies and similar technologies.
						</p>
					</div>

					<div className="privacy-section">
						<h2>8. Your Rights</h2>
						<p>Subject to applicable UK data protection law, you may have the right to:</p>
						<ul>
							<li>Ask for a copy of the personal information we hold about you</li>
							<li>Ask us to correct inaccurate or incomplete information</li>
							<li>Ask us to delete information where there is no lawful reason to keep it</li>
							<li>Object to or restrict certain uses of your information</li>
							<li>Withdraw consent where processing is based on consent</li>
						</ul>
						<p>
							To make a request, contact us using the details below. We may need to verify your
							identity before responding.
						</p>
					</div>

					<div className="privacy-section">
						<h2>9. Contact Us</h2>
						<p>If you have a privacy question or believe your information has been misused, contact:</p>
						<ul>
							<li><strong>West Drayton Body Works Ltd</strong></li>
							<li><strong>Phone:</strong> 02045793699</li>
							<li><strong>Email:</strong> support@westdraytonbodyworks.com</li>
							<li><strong>Address:</strong> Unit 4 The Common, West Drayton, UB7 7EG, United Kingdom</li>
						</ul>
						<p>
							You also have the right to contact the UK Information Commissioner's Office if you
							are unhappy with how we handle your personal information.
						</p>
					</div>

					<div className="privacy-section privacy-footer">
						<p><strong>Last Updated:</strong> September 2026</p>
					</div>
				</section>
			</div>
		</main>
	);
};

export default PrivacyPolicies;
